import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Pencil } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { FIELDS } from "@/components/quest/QuestNewForm";

export function QuestGoalsEdit({ q, onDone }) {
  const cur = Object.fromEntries(q.goals.map((g) => [g.kind, g]));
  const [vals, setVals] = useState(Object.fromEntries(FIELDS.map(([k]) => [k, cur[k]?.goal || ""])));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/quest/goals", { goals: Object.fromEntries(Object.entries(vals).map(([k, v]) => [k, Number(v) || 0])) });
      toast.success(data.pushed ? "Ziele aktualisiert – Push zum neuen Ziel an alle gesendet 🔔" : "Ziele aktualisiert – alle sehen sofort die neuen Ziele");
      onDone();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-red-100 bg-white p-4 space-y-3" data-testid="admin-quest-goals-edit">
      <p className="text-sm font-bold flex items-center gap-1.5"><Pencil className="w-4 h-4 text-rose-500" /> Ziele anpassen oder hinzufügen</p>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="space-y-1">
            <span className="text-xs font-semibold text-slate-600">{label}{cur[k] ? <span className="text-slate-400"> · aktuell {cur[k].count}</span> : ""}</span>
            <input type="number" min="0" max="100000" inputMode="numeric" value={vals[k]} placeholder="0 = aus" onChange={(e) => setVals((v) => ({ ...v, [k]: e.target.value }))}
              data-testid={`admin-quest-goal-${k}`} className="w-full h-10 px-3 rounded-xl border border-pink-100 text-sm focus:outline-none focus:ring-2 focus:ring-rose-200" />
          </label>
        ))}
      </div>
      <p className="text-xs text-slate-400">0 oder leer = Ziel entfernen. Bisherige Beiträge seit Start der Aufgabe zählen bei neuen Zielen sofort mit. Kommt ein neues Ziel dazu, bekommen alle automatisch eine Push-Mitteilung.</p>
      <button onClick={save} disabled={busy} data-testid="admin-quest-goals-save" className="h-10 px-5 rounded-full pink-gradient text-white text-sm font-bold inline-flex items-center gap-1.5">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Ziele speichern
      </button>
    </div>
  );
}
